import pastorsPic from '../assets/img/pastorsAltar1.jpg';
import caballerosPresidentPic from '../assets/img/daniel2.jpg';
import damasPresidentPic from '../assets/img/noris.jpg';
import jovenesPresidentPic from '../assets/img/dileny2.jpeg';
import ninosPresidentPic from '../assets/img/bajoConstruccion1.jpg';
import churchPic from '../assets/img/churchFront.jpg';
import caballerosGroupPic from '../assets/img/Caballeros_2026.jpg';
import damasGroupPic from '../assets/img/Damas_2026.JPG';
import jovenesGroupPic from '../assets/img/Jovenes_2026.JPG';
import ninosGroupPic from '../assets/img/bajoConstruccion2.jpg';
import Superintendenta from '../assets/img/anita.jpg';

export const NAVPAGES = [
    {
        id: 0,
        navTitle: 'Home',
        title1: 'Iglesia Pentecostal',
        title2: 'Estrella de Jacob',
        subTitle: 'La mas linda del Bronx!',
        content:'Por la gracia de nuestro Señor Jesucristo estamos estrenando nuestra nueva página cibernética.\nPor estos medios le queremos dar la mas cordial bienvenida, donde esperamos que puedan conocer más a la Iglesia Pentecostal Estrella de Jacob, "La más linda del Bronx."\nLe invitamos para que explore nuestras sociedades, nuestro historial, eventos anuales, y calendario.\nPodrá también contactarnos, si así lo desea y dejarnos sus oraciones, peticiones y comentarios.\nEsperamos que esta pagina sea de gran bendición a todos ustedes.  Por cierto, mas detalles y funciones serán agregadas a la página mientras avanzamos en esta aventura cibernética.\nNuestro Señor Jesucristo nos ha encomendado de “id por todo el mundo y predicad el evangelio a toda criatura.”  De esta manera creemos que nuestro alcance será más efectivo, alcanzando mas personas de diferentes indoles de la vida en este mundo.\nDios les bendiga y nos veremos pronto.\nSu Pastor,\nRev. Dr. Aurelio Rexach',
        image: pastorsPic,
        path:'/home',
        icon: 'fa-home',
        leaderTitle: 'Pastores',
        leaderName: 'Rev. Aurelio y Gladys Rexach'
    },
    {
        id: 1,
        navTitle: 'Caballeros',
        title: 'Sociedad de Caballeros',
        subTitle: 'Procura con diligencia presentarte a Dios aprobado, como obrero que no tiene de qué avergonzarse, que usa bien la palabra de verdad.',
        verse: '~ 2 Timoteo 2:15',
        content: 'Reciban un abrazo cordial de parte de la Sociedad de Caballeros "Heraldos de Cristo."\nUna sociedad de hombres que estamos dedicados a predicar la palabra que nuestro Señor Jesucristo nos ha instruido y queremos que cada caballero sepa el gran valor y compromiso que Dios a dado a su vidas.\nDel mismo modo que cada uno de nosotros estamos creciendo día a día en la fe, la hermandad y el servicio, buscamos hombres cansados de vivir en un mundo donde los valores que forman el núcleo familiar están en decadencia.\nHacemos un llamado para unirse a nosostros los dias de semana para escuchar la palabra de Dios que traerán paz y descanso a las almas sedientas de amor y paz.  Recuerda que hoy más que nunca el mundo necesita hombres de fe, valor y compromiso.\nLas puertas de la iglesia estan abiertas y nosotros estaremos muy contentos de saludarle personalmente.\nDios le bendiga!',
        image: caballerosPresidentPic,
        path:'/caballeros',
        leaderTitle: 'Presidente de Caballeros',
        leaderName: 'Daniel Carrales',
        vpName: 'David Membreño',
        vpTitle: 'Vice Presidente',
        secName: 'Jose Rodriguez',
        secTitle: 'Secretario',
        groupImage: caballerosGroupPic
    },
    {
        id: 2,
        navTitle: 'Damas',
        title: 'Sociedad de Damas',
        subTitle: 'Engañosa es la gracia, y vana la hermosura; la mujer que teme a Jehova, esa sera alabada.',
        verse: '~ Proverbios 31:30',
        content:'Por este medio la sociedad de damas le quiere dar la más cordial bienvenida a nuestra iglesia, la cual rebosa de mujeres que al igual que usted, ama al Señor y a su obra.  Mujeres reformadas y transformadas por la obra de Jesucristo.\nCreemos firememente en que la mujer aparte de ser esposa, madre, amiga y sierva del Señor, con esfuerzo y dedicación puede llevar un equilibrio entre cada uno de estos roles.  Dios nos ha dotado de virtudes y talentos que quiere que pongamos a su disposición y a su servicio para así multiplicarlos, desarrollarlos, para que sean de bendición en la iglesia del Señor.  Por lo tanto, brindamos oportunidades durante todo el año para que las damas se reúnan para compartir, orar, llegar a la comunidad, retiros, conferencias y mucho más.\nCada mujer que le sirve al Señor tiene un carácter modelado por valores y principios arraigados en su ser, para que el mundo pueda ver que aun en estos tiempos todavia hay mujeres que apartadas para el Señor producen cambios a su alrededor.\nEstos cambios son producidos por el Espíritu Santo el cual recibimos el día que confesamos a Jesucristo como nuestro salvador.  Te invitamos a conocerlo si aún no lo has recibido.\nTómese la libertad de visitarnos cuando quiera, estamos ansiosas de tenerle con nosotros.\nSi no puede venir, puede unirse a nosotros virtualmente a través de nuestras transmisiones en vivo.\nEsperamos verle pronto y que Dios le bendiga.  ',
        image: damasPresidentPic,
        path:'/damas',
        leaderTitle: 'Presidenta de Damas',
        leaderName: 'Noris Rodriguez',
        vpName: 'Yanilda Rodriguez',
        vpTitle: 'Vice Presidenta',
        secName: 'Janie Collazo',
        secTitle: 'Secretaria',
        groupImage: damasGroupPic
    },
    {
        id: 3,
        navTitle: 'Jovenes',
        title: 'Sociedad de Jovenes',
        subTitle: 'Porque tú, oh Señor Jehová, eres mi esperenza, seguridad mia desde mi juventud.',
        verse: '~ Salmos 71:5',
        content:'Nuestro objetivoes levantar jóvenes que puedan mantener una relacion genuina con el Señor.  Jóvenes que busquen al Señor con toda sus fuerzas, mente y corazón para impactar al mundo de una manera positiva.  Estamos viviendo en tiempos de tanta maldades pero solo en Cristo podemos obtener la esperanza y seguridad de ser la luz en medio de las tinieblas.\nEste mundonecesita ver la gloria y poder de Dios y oramos que la juventud puedan tomar parte en la obra de Dios.  Que Dios nos llene del Espíritu Santo!  Desamos que los dones y milagros se manifiesten en los jovenes para que el mundo sepa que Dios todavia hace prodigios, que es poderoso y que no hat NADA imposible para el.\nEs tiempo de que la juventud se levante y den testimonio de quien es nuestro Dios.\nDios les bendiga! ',
        content2: '',
        image: jovenesPresidentPic,
        path:'/jovenes',
        leaderTitle: 'Presidenta de Jovenes',
        leaderName: 'Dileny Veloz',
        vpName: 'Yanet Flores',
        vpTitle: 'Vice Presidenta',
        secName: 'Jasmine Lopez',
        secTitle: 'Secretaria',
        groupImage: jovenesGroupPic
    },
    {
        id: 4,
        navTitle: 'Ninos',
        title: 'Sociedad de Niños',
        subTitle: 'Instruye al niño en su camino, Y aun cunado fuere viejo no se apartará de él.',
        verse: '~ Proverbios 22:6',
        content:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio exercitationem nulla doloribus, vel perspiciatis maiores animi praesentium. Officiis reprehenderit assumenda quam amet mollitia repudiandae iusto, dignissimos quos. Totam, eaque vel. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio exercitationem nulla doloribus, vel perspiciatis maiores animi praesentium. Officiis reprehenderit assumenda quam amet mollitia repudiandae iusto, dignissimos quos. Totam, eaque vel. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio exercitationem nulla doloribus, vel perspiciatis maiores animi praesentium. Officiis reprehenderit assumenda quam amet mollitia repudi. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio exercitationem nulla doloribus, vel perspiciatis maiores animi praesentium. Officiis reprehenderit assumenda quam amet mollitia repudiandae iusto, dignissimos quos. Totam, eaque vel. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio exercitationem nulla doloribus, vel perspiciatis maiores animi praesentium. Officiis reprehenderit assumenda quam amet mollitia repudiandae iusto, dignissimos quos. Totam, eaque vel.',
        image: ninosPresidentPic,
        path:'/ninos',
        leaderTitle: 'Presidente de Niños',
        leaderName: '',
        vpName: '',
        vpTitle: 'Vice Presidente',
        secName: '',
        secTitle: 'Secretario',
        groupImage: ninosGroupPic
    },
    {
        id: 5,
        navTitle: 'Escuela Dominical',
        title: 'Escuela Dominical',
        subTitle: 'para que andéis como es digno del Señor, agradándole en todo, llevando fruto en toda buena obra, y creciendo en el conocimiento de Dios;',
        verse: 'Colosenses 1:10',
        content:'El propósito de la Escuela Bíblica es instruir la palabra de Dios a todo aquel miembro del cuerpo de Jesucristo, con la finalidad de llegar a un crecimiento personal en su caminar en el evangelio, así mismo el poder entender e interpretar las escrituras a travez de la instrucción y la revelación del Espíritu Santo.\nEso quiere decir que venir a la Escuela Bíblica hace una gran diferencia en la vida de las personas.\nBeneficios de la Escuela Bíbilca:\n○ Las personas vienen a los pies de Jesucristo.\n○ Interes y confraternidad:  Nuevas personas vienen a ser parte de nuestras vidas.\n○ Estudio de la Bíblia transforma a las personas y ellos experimentan crecimiento espiritual y desarrollo.\n○ Dones espirituales y habilidades son usados para beneficio de la iglesia.\n○ Los lazos familiares son unidos porque Jesus esta en sus vidas.',
        image: Superintendenta,
        path:'/escueladominical',
        leaderTitle: 'Superintendenta',
        leaderName: 'Ana Guevara',
        vpName: 'Yunid Tavarez',
        vpTitle: 'Sub-Superintendente',
        secName: 'Genoveva Cajigas',
        secTitle: 'Secretaria',
        groupImage: ninosGroupPic
    },
    {
        id: 6,
        navTitle: 'DeNosotros',
        title: 'Quienes Somos?',
        content: 
                <>
                    <p>
                        Estando el Pastor, Juan Corales residiendo en Nueva York, tuvo la siguiente revelación mientras dormía: 
                        De momento vio a un joven que llegaba hasta donde él y le dijo estas palabras: "Vamos a levantarle una 
                        obra a Jehová;" el pastor Corales le contestó: "Vamos." Luego los dos se montaron en un camión militar y 
                        al llegar a cierto lugar, el joven lo dejó solo. Al encontrarse solo, el Pastor Corales se sintió muy 
                        triste y dijo estas palabras: "Si apareciera el Apóstol Pablo y me diera una campaña!" Luego que él hablo
                        estas palabras oyó una voz que le dijo, "Pero el Apóstol Pablo está muerto." De momento el miró para todos
                        lados y vio una biblía a través de una vitrina cerrada, cuyas páginas empezaban a cambiarse por sí solas, 
                        proyectando una luz propia de ellas. Inmediatemente, despertó y se preguntó que sería aquello, y el Señor 
                        le mostro que él tenía que depender solamente de su Palabra.
                    </p>
                    <p>
                        Después de esto, el Pastor Corales y su esposa, Justina, se trasladaron a Puerto Rico y mientras atendía una 
                        obra en el pueblo de Aguadilla, su pueblo natal, el Señor le habló en revelación usando a un joven como de 14 años, 
                        quien le dijo estas palabras: "tienes que volver a Nueva York." El Pastor Corales había pensado quedarse en su pueblo, 
                        pero al oír la voz del Señor sintió temor y regresó.
                    </p>
                    <p>
                        Una mañana, los pastores Corales se hallaban en la calle 156 y 3ra avenida, y se encontraron con el joven 
                        de la visión. El joven le dijo al Pastor Corales las mismas palabras que ya él había escuchado en aquella 
                        revelación primera, "vamos a levantar una obra a Jehová por la calle 183 y 184." Por la tarde hicieron los 
                        arreglos y se reunieron en el hogar de un inconverso que le gustaba oír de la Palabra de Dios. A la semana 
                        dieron un servicio en este hogar y los dueños del hogar se convirtieron al Señor. Siguieron dando cultos en 
                        los hogares y almas se convertían y el joven de la visión los acompañaba a todos los servicios. Más luego, 
                        teniendo un grupo de aproximadamente 11 almas decidieron buscar un lugar con mayores facilidades para adorar 
                        a Dios. Encontraron un lugar pequeño en el 54 E. de la calle 184 y cuando empezaron a arreglar este lugar, 
                        el joven se marchó a Boston y nunca más se supo de él.
                    </p>
                    <p>
                        El día 20 de Febrero de 1971 se celebró el servicio de inaugración de la Iglesia Estrella de Jacob. Habían 11 
                        hermanos presentes y el Señor siguió bendiciendo la obra de manera especial, añadiendo muchas almas. Viendo el 
                        crecimiento, era preciso buscar otro lugar más amplio para congregarse. Así se le fue añadiendo al templo, 
                        comprando los negocios vecinos.
                    </p>
                    <p>
                        En el mes de Noviembre del 1979, salieron los Pastores Corales a Puerto Rico, dajando así la Iglesia Estrella 
                        de Jacob afiliada al <a href="https://claiddp.org/" target="_blank" rel="noopener noreferrer">Concilio Latino Americano</a> en común acuerdo con la oficialidad y la congregación.
                    </p>
                </>,
        image: churchPic,
        leaderName: 'Iglesia Pentecostal Estrella de Jacob, Inc',
        path:'/aboutus',
        icon:'fa-info'
    },
    {
        id: 7,
        navTitle:'Eventos',
        title: 'Eventos',
        path:'/events',
        icon:'fa-bolt'
    },
    {
        id: 8,
        navTitle:'Calendario',
        title: 'Calendario',
        path:'/calendar',
        icon:'fa-calendar'
    },
    {
        id: 9,
        navTitle:'Contactenos',
        title: 'Contactenos',
        path:'/contactus',
        icon:'fa-address-card'
    }  
];